module.exports = __webpack_public_path__ + "img/WBlogo.af8bbd14.gif";